import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SkeletonComponent } from './components/skeleton/skeleton.component';
import { SkeletonDirective } from './directives/skeleton.directive';
import { TableSkeletonDirective } from './directives/table-skeleton.directive';
import { TableSkeletonComponent } from './components/table-skeleton/table-skeleton.component';
import { HideContentSkeletonDirective } from './directives/hide-content-skeleton.directive';
import { NavbarSkeletonComponent } from './components/navbar-skeleton/navbar-skeleton/navbar-skeleton.component';
import { NavbarSkeletonDirective } from './directives/navbar-skeleton.directive';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { ProgressBarModule } from 'primeng/progressbar';

@NgModule({
  imports: [CommonModule, ProgressBarModule],
  declarations: [
    SpinnerComponent,
    SkeletonComponent,
    SkeletonDirective,
    TableSkeletonComponent,
    TableSkeletonDirective,
    HideContentSkeletonDirective,
    NavbarSkeletonComponent,
    NavbarSkeletonDirective,
    ProgressBarComponent,
  ],
  exports: [SpinnerComponent, SkeletonDirective, TableSkeletonDirective, HideContentSkeletonDirective, NavbarSkeletonComponent, NavbarSkeletonDirective, ProgressBarComponent],
})
export class SharedFeatureLoadingModule {}
